import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { Item } from "src/app/inspection/model/item";
import { ProductsListConfig } from "src/app/inspection/permissions-setter/permissions-interface";

@Component({
    selector: "im-items-container",
    templateUrl: "./items-container.component.html",
    styleUrls: ["./items-container.component.scss"],
    standalone: false
})
export class ItemsContainerComponent implements OnInit, OnChanges {
  @Input()
  items: Item[];

  @Input()
  inspectionId: string = null;

  @Input()
  itemId: string = null;

  @Input()
  config: ProductsListConfig = {
    allowOpenDetails: false,
    allowOpenConfig: false,
    allowDelete: false,
    isReadOnly: false,
  };

  @Output()
  selectedItemChanged: EventEmitter<Item> = new EventEmitter<Item>();

  @Output()
  deletedItem: EventEmitter<Item> = new EventEmitter<Item>();

  @Output()
  editedItem: EventEmitter<Item> = new EventEmitter<Item>();

  @Output()
  editAction: EventEmitter<void> = new EventEmitter<void>();

  selectedItem: Item = null;

  constructor() {}

  ngOnInit(): void {
    if (this.itemId) {
      this.selectedItem = this.items.find((i) => i.id == this.itemId);
      this.selectedItemChanged.next(this.selectedItem);
    }
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    this.updateSelectedItem(simpleChanges.items.currentValue);
  }

  onSelectedItemChanged(item: Item) {
    this.selectedItem = item;
    this.selectedItemChanged.next(this.selectedItem);
  }

  onEditedItem(editedItem: Item) {
    this.editedItem.next(editedItem);
  }

  onEditAction() {
    this.onGoBackEvent();
  }

  onDeletedItem(deletedItem: Item) {
    this.deletedItem.next(deletedItem);
    this.onGoBackEvent();
  }

  onGoBackEvent() {
    this.selectedItem = null;
    this.selectedItemChanged.next(this.selectedItem);
  }

  getItemListClass() {
    return this.selectedItem ? "mini-list" : "";
  }

  private updateSelectedItem(updatedItems: Item[]) {
    if (updatedItems?.length && this.selectedItem) {
      const currentUpdatedItem = updatedItems.find(
        (item) => item.name === this.selectedItem.name,
      );
      this.selectedItem = Object.assign({}, currentUpdatedItem);
    }
  }
}
